var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCandidate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#112d55",
    d: "M16.75 7.5c0-2.895-2.355-5.25-5.25-5.25S6.25 4.605 6.25 7.5c0 1.603.738 3.023 1.874 3.987a7.7 7.7 0 0 0-3.605 2.033A7.702 7.702 0 0 0 2.249 19a2.752 2.752 0 0 0 2.75 2.75h7a.75.75 0 0 0 0-1.5h-7c-.689 0-1.25-.561-1.25-1.25 0-1.669.65-3.239 1.83-4.42a6.212 6.212 0 0 1 4.42-1.83h2.68a.735.735 0 0 0 .607-.334c2.013-.735 3.463-2.651 3.463-4.916zm-5.25 3.75c-2.067 0-3.75-1.682-3.75-3.75s1.683-3.75 3.75-3.75 3.75 1.682 3.75 3.75-1.683 3.75-3.75 3.75z",
    opacity: 1,
    "data-original": "#112d55",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0e9941",
    d: "m21.53 20.47-1.688-1.688a4.72 4.72 0 0 0 .257-5.182 4.757 4.757 0 0 0-6.499-1.7 4.72 4.72 0 0 0-2.196 2.896 4.723 4.723 0 0 0 .496 3.603 4.72 4.72 0 0 0 2.896 2.196 4.73 4.73 0 0 0 3.603-.496c.134-.078.247-.179.371-.269l1.699 1.699a.748.748 0 0 0 1.06 0 .75.75 0 0 0 0-1.061zm-3.889-1.665a3.235 3.235 0 0 1-2.465.34c-.84-.22-1.543-.754-1.981-1.503s-.56-1.625-.34-2.465.754-1.543 1.503-1.981a3.251 3.251 0 0 1 4.787 3.628 3.227 3.227 0 0 1-1.503 1.981z",
    opacity: 1,
    "data-original": "#549bff",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidate);
export default __webpack_public_path__ + "static/media/candidate.70d1ed88a63d3601cab44831462f617a.svg";
export { ForwardRef as ReactComponent };